module.exports = __webpack_public_path__ + "static/img/Product_size.41e53fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/phone/Product_size.png
// module id = aDbv
// module chunks = 1